'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isString = require('is-string');

var _isString2 = _interopRequireDefault(_isString);

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var format = function format(value) {
  return (0, _isString2.default)(value) ? value.replace(/[^a-zA-Z\s]/g, '').split(' ').map(function (word) {
    return '' + word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ') : '';
};

var validate = function validate(value) {
  return value.split(' ').filter(function (word) {
    return !!('' + word);
  }).map(function (word) {
    return word.trim().length > 0 && /^[a-zA-Z]+$/.test(word) && word.charAt(0) === word.charAt(0).toUpperCase();
  }).every(function (word) {
    return word;
  });
};

exports.default = (0, _type2.default)({
  type: 'string',
  format: format,
  validate: validate
});